<template>
  <div>
    <el-button icon="el-icon-plus" type="primary" @click="dialogVisible = true">
      添加批次
    </el-button>
    <el-dialog
      :visible="dialogVisible"
      title="添加批次"
      width="600px"
      @close="closeDialog"
    >
      <el-form :model="batchDetail" ref="batchForm" class="banner-form" :rules="rules" label-width="100px">
        <el-form-item label="批次：" prop="batchNo">
          <el-input-number v-model="batchDetail.batchNo" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item label="标题：" prop="title">
          <el-input v-model="batchDetail.title"></el-input>
        </el-form-item>
        <el-form-item label="批次时间：" required>
          <el-col :span="11">
            <el-form-item prop="startTime">
              <el-date-picker type="datetime" placeholder="开始时间" v-model="batchDetail.startTime" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">~</el-col>
          <el-col :span="11">
            <el-form-item prop="endTime">
              <el-date-picker type="datetime" placeholder="结束时间" v-model="batchDetail.endTime" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
         <el-form-item label="币种：" prop="coinType">
          <el-select v-model="batchDetail.coinType" multiple placeholder="请选择" class="coin-selection">
            <el-option
              v-for="item in coinList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
              <div class="coin-selection-label">
                <img :src="item.logo" />
                <span class="text">{{ item.label }}</span> 
              </div>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('batchForm')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'CreateBatch',
  data() {
    return {
      dialogVisible: false,
      batchDetail: {
        coinType: []
      },
      rules: {
        batchNo: [{ required: true, message: '请输入批次' }],
        title: [{ required: true, message: '请输入标题' }],
        startTime: [{ required: true, message: '请输入开始时间' }],
        endTime: [{ required: true, message: '请输入结束时间' }]
      }
    };
  },
  computed: {
    ...mapGetters('voteBatchSetting', ['coinList'])
  },
  methods: {
    ...mapActions('voteBatchSetting', ['createBatch']),
    closeDialog() {
      this.dialogVisible = false;
      this.batchDetail = {
        coinType: []
      };
      this.$refs['batchForm'].resetFields();
    },
    handleSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.createBatch({
            ...this.batchDetail,
            startTime: moment(this.batchDetail.startTime).valueOf(),
            endTime: moment(this.batchDetail.endTime).valueOf(),
            coinType: this.batchDetail.coinType.join(',')
          }).then(() => {
            this.$message.success('添加成功！');
            this.dialogVisible = false;
            this.$emit('refresh');
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.line {
  text-align: center;
}

.coin-selection {
  width: 100%;
}

.coin-selection-label {
  line-height: normal;

  img {
    width: 20px;
    height: 20px;
    vertical-align: middle;
    margin-right: 5px;
  }

  .text {
    vertical-align: middle;
  }
}
</style>
